/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useCallback, useEffect, useState } from "react";

import { usePlayerController } from "../BasePlayer";

export const usePlayerPlayingState = () => {
  const { player } = usePlayerController();

  const [isPlaying, setIsPlaying] = useState<boolean>(!player.isPaused());

  const togglePlay = useCallback(() => {
    player.isPaused() ? player.play() : player.pause();
  }, [player]);

  useEffect(() => {
    setIsPlaying(!player.isPaused());

    const unsubscribePlay = player.onEvent(["play", "playing"], () => {
      setIsPlaying(true);
    });
    const unsubscribePause = player.onEvent(["pause", "ended"], () => {
      setIsPlaying(false);
    });

    return () => {
      unsubscribePlay();
      unsubscribePause();
    };
  }, [player]);

  return { isPlaying, togglePlay };
};
